module.exports = __webpack_public_path__ + "img/LM_map_custome.60c5e833.svg";